const { Schema, Mapper } = require('js-data')

let mapper_options = {
  name: 'landing_page_widget',
  endpoint: 'landing_page_widgets',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      landing_page: {
        localKey: 'landing_page_id',
        localField: 'landing_page'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('landing_page_widget', mapper_options)
}
